<template>
    <div class="w-full">

        <h4 class="mb-3">Subscribers</h4>

        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addSubscriberPrompt = true">Add</vs-button>

        <vx-card id="subscribersDiv"  class="vs-con-loading__container">

            <vs-table ref="table" @selected="openSubscriber" :data="tableData" class="mt-3" pagination search :maxItems="itemsPerPage">
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="erp_reference_id">ERP Reference</vs-th>
                    <vs-th sort-key="name">Name</vs-th>
                    <vs-th sort-key="email">Email</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].erp_reference_id">
                            {{ data[index].erp_reference_id }}
                        </vs-td>

                        <vs-td :data="data[index].name">
                            {{ data[index].name }}
                        </vs-td>

                        <vs-td :data="data[index].email">
                            {{ data[index].email }}
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>

        <vs-popup title="Add Subscriber" :active.sync="addSubscriberPrompt">
            <div id="addSubscriberDiv" class="vs-con-loading__container" >
                <p class="mt-6">ERP Reference</p>
                <vs-input v-model="addObject['erp_reference_id']" class="w-full"></vs-input>
                <p class="mt-6">Name</p>
                <vs-input v-model="addObject['name']" class="w-full"></vs-input>
                <p class="mt-6">Name</p>
                <vs-input v-model="addObject['email']" class="w-full"></vs-input>
                <p class="mt-6">Name</p>
                <vs-textarea v-model="addObject['additional_notes']" class="w-full"></vs-textarea>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addSubscriber">Add</vs-button>
            </div>
        </vs-popup>
    </div>
</template>
<script>

export default {
    data(){
        return {

            itemsPerPage: 20,
            isMounted: false,

            subscribers: [],

            addSubscriberPrompt: false,

            addObject: {}

        }
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#subscribersDiv',
                type: 'corners',
                scale: 0.7
            })

            const thisIns = this
            const loadPromise = this.$http.get('/api/management/v1/subscriber/')
            loadPromise.then(function(response) {
                thisIns.subscribers = response.data
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            }).finally(function() {
                thisIns.$vs.loading.close('#subscribersDiv > .con-vs-loading')
            })
        },
        addSubscriber() {
            this.$vs.loading({
                container: '#addSubscriberDiv',
                type: 'corners',
                scale: 0.7
            })

            const thisIns = this

            const addPromise = this.$http.post('/api/management/v1/subscriber/', {
                erp_reference_id: Number(this.addObject.erp_reference_id),
                name: this.addObject.name,
                email: this.addObject.email,
                additional_notes: this.addObject.additional_notes,
            })

            addPromise.then(function(response) {
                thisIns.addSubscriberPrompt = false
                thisIns.$printSuccess('Subscriber')
                thisIns.$nextTick(() => {
                    thisIns.$router.push("/subscriber/" + response.data.id);
                })
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            }).finally(function() {
                thisIns.$vs.loading.close('#addSubscriberDiv > .con-vs-loading')
            })
        },
        openSubscriber(tr) {
            this.$router.push('/subscriber/' + tr.id)
        }
    },
    computed: {
        currentPage() {
            if (this.isMounted) {
                return this.$refs.table.currentx
            }
            return 0
        },
        tableItems() {
            if (this.isMounted) {
                return this.$refs.table.queriedResults.length
            }
            return 0
        },
        tableData() {
            return this.subscribers
        }
    },
    mounted() {
        this.isMounted = true
        this.loadData()
    }
}

</script>
